import './WomenInQuantumPage.css';
import { BookOpen, Users, Briefcase, ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const pillars = [
  {
    icon: BookOpen,
    title: 'Education',
    body: 'Specialised quantum computing courses and workshops designed for all skill levels — no prior quantum background required to begin.',
  },
  {
    icon: Users,
    title: 'Mentorship',
    body: 'Connect with leading women in quantum science and technology for guided mentorship, peer support, and career coaching.',
  },
  {
    icon: Briefcase,
    title: 'Opportunities',
    body: 'Access internships, research collaborations, fellowships, and career pathways at the intersection of gender equity and quantum tech.',
  },
];

const faqs = [
  {
    q: 'Who can apply?',
    a: 'Any woman or non-binary person with an interest in quantum technology — no prior experience required. Curiosity is the only prerequisite.',
  },
  {
    q: 'Is the programme free?',
    a: 'Yes, entirely. The programme is free to ensure accessibility and inclusion across all economic backgrounds.',
  },
  {
    q: 'How long does it run?',
    a: 'The programme runs for 6 months, with monthly live sessions, self-paced content, and continuous mentorship throughout.',
  },
];

export default function WomenInQuantumPage() {
  return (
    <div className="wiq-page">
      <Helmet>
        <title>Women in Quantum | QuantumKE</title>
        <meta name="description" content="QuantumKE's Women in Quantum initiative empowers women and non-binary individuals with quantum education, mentorship, and career opportunities across Kenya and Africa." />
        <link rel="canonical" href="https://quantumke.org/wiq" />
      </Helmet>

      {/* ── HERO ── */}
      <section className="wiq-hero">
        <div className="wiq-hero-overlay" />
        <div className="wiq-hero-inner">
          <span className="wiq-label">Engagement Programme</span>
          <h1 className="wiq-hero-title">Women in Quantum</h1>
          <p className="wiq-hero-sub">
            Empowering women to lead the quantum revolution through education, mentorship, and community.
          </p>
          <a
            href="https://forms.gle/m39c5JC382xB537QA"
            target="_blank"
            rel="noopener noreferrer"
            className="wiq-btn-primary"
          >
            Apply Now <ArrowRight size={16} />
          </a>
        </div>
      </section>

      {/* ── MISSION ── */}
      <section className="wiq-section">
        <div className="wiq-container">
          <div className="wiq-section-head">
            <span className="wiq-label">Our Mission</span>
            <h2 className="wiq-section-title">Closing the Gender Gap in Quantum</h2>
            <p className="wiq-section-desc">
              The Women in Quantum Programme is dedicated to increasing diversity in quantum technology by providing resources, mentorship, and opportunities for women at all career stages — from students to working professionals.
            </p>
          </div>
          <div className="wiq-pillars-grid">
            {pillars.map(({ icon: Icon, title, body }) => (
              <div key={title} className="wiq-pillar-card">
                <div className="wiq-pillar-icon">
                  <Icon size={22} />
                </div>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="wiq-section wiq-faq-section">
        <div className="wiq-container">
          <div className="wiq-section-head">
            <span className="wiq-label">Questions</span>
            <h2 className="wiq-section-title">Frequently Asked Questions</h2>
          </div>
          <div className="wiq-faq-grid">
            {faqs.map(({ q, a }) => (
              <div key={q} className="wiq-faq-card">
                <h3>{q}</h3>
                <p>{a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
